export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * VOC real (ficha DPS65, sección 2.3): frases textuales de técnicos, dueños de
 * sistema y la industria en foros y publicaciones públicas, con su fuente.
 * NO son reseñas del producto y la página lo aclara.
 */
export const leaderVoices: Voice[] = [
  {
    quote: 'I need to prove 100% if the fault is on the array or not',
    author: 'An electrician diagnosing an orphaned system',
    source: 'ElectriciansForums (UK)',
  },
  {
    quote: 'The voltage test has not always been accurate',
    author: 'An electrician repairing inverters for a solar company',
    source: 'Mike Holt Forum, 2025',
  },
  {
    quote: 'made no sense',
    author: 'The same tech, on the field method for finding ground faults',
    source: 'Mike Holt Forum, 2025',
  },
]

export const moreLeaderVoices: Voice[] = [
  {
    quote:
      'what initially appears to be a bad inverter may instead be a symptom of a problem elsewhere',
    author: 'A field technician’s guide to inverter troubleshooting',
    source: 'Solar Builder, “Fault Busters”',
  },
  {
    quote: 'the horror stories of reversed CTs and half-production',
    author: 'A commenter in a solar community',
    source: 'r/solar, 2025',
  },
  {
    quote:
      'without a person behind to ask and clarify concepts this is impossible',
    author: 'A system owner with unbalanced battery cells',
    source: 'Victron Community, 2021',
  },
]
